<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="dep-create-form__section">
          <div class="dep-create-form__section-title">
            {{ $t('orgs.subdivision_note') }}
          </div>
          <el-input type="textarea" :placeholder="$t('labels.description')" v-model="depData.description"></el-input>
          <div class="dep-create-form__section-title">
            {{ $t('labels.address') }}
          </div>
                    <el-input :placeholder="$t('labels.address')"
                    v-model="depData.address"
                    v-bind:class="{ showLabel: depData.address || error.address.invalid, error: error.address.invalid}"
                    ref="inputAddress">
                    <label v-if="error.address.invalid"
                      class="label-error"
                      slot="prefix">
                      {{ error.address.message }}
                    </label>
            <label v-else slot="prefix">{{ $t('labels.address') }}</label>
          </el-input>
          <div class="dep-create-form__section-title">
            {{ $t('labels.contacts') }}
          </div>
          <div class="dep-create-another-contacts">
            <div class="dep-create-another-contacts__row" v-for="(contact, index) in anotherContacts" :key="index">
              <el-input :placeholder="$t('labels.title')" v-model="anotherContacts[index].type"></el-input>
              <el-input v-model="anotherContacts[index].value" :placeholder="$t('labels.contacts')"></el-input>
              <img class="dep-create-another-contacts__delete" @click="deleteAnotherContact(index)" :title="$t('labels.delete')"
                       src="static/img/icon_dropmenu_trash.svg"/>
            </div>
            <div class="dep-create-another-contacts__add">
              <span @click="addAnotherContact">
                {{ $t('labels.add') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dep-create__nav-buttons">
      <el-button @click="prev" icon="el-icon-arrow-left">{{ $t('labels.prev') }}</el-button>
      <el-button @click="next" >{{ $t('labels.skip') }} <i class="el-icon-arrow-right el-icon-right"></i></el-button>
      <el-button type="primary"
               @click="next">{{ $t('orgs.add_subdivision') }} <i class="el-icon-arrow-right el-icon-right"></i></el-button>
    </div>
  </div>
</template>
<script>
  import MaskedInput from 'vue-masked-input'
  import lodash from 'lodash'

  export default {
    props: {
      currentStep: Number
    },
    components: {
      MaskedInput
    },
    data () {
      return {
        depData: {
          description: '',
          contacts: [],
          address: ''
        },
        phones: [{
          number: '',
          name: ''
        }],
        anotherContacts: [{
          type: '',
          value: ''
        }],
        error: {
          address: {
            invalid: false,
            message: ''
          }
        }
      }
    },
    methods: {
      isStepValid () {
        this.validate();

        let error = this.error;
        let isValid = true;
        for (let item in error) {
          if (this.error[item].invalid === true) {
            isValid = false;
          }
        }
        return isValid;
      },
      setError (key, message) {
        this.error[key].invalid = true;
        this.error[key].message = message;
      },
      validate () {
        if (this.address) {
          if (!this.depData.address) {
            this.setError('address', this.$t('orgs.confirm_address'))
          }
        }
      },
      resetError () {
        let error = this.error;

        for (let item in error) {
          this.error[item].invalid = false;
          this.error[item].mesage = '';
        }
      },
      addPhone () {
        this.phones.push({
          number: '',
          name: ''
        })
      },
      deletePhone (index) {
        this.phones.splice(index, 1);
      },
      addAnotherContact () {
        this.anotherContacts.push({
          value: '',
          name: ''
        })
      },
      deleteAnotherContact (index) {
        this.anotherContacts.splice(index, 1);
      },
      setPhones () {
        let phones = []
        for (let phone of this.phones) {
          if (phone.number) {
            phones.push({
              number: phone.number,
              name: phone.name
            })
          }
        }

        if (phones.length > 0) {
          this.depData.contacts.phones = phones
        } else {
          this.depData.contacts.phones = null
        }
      },
      setAnotherContacts () {
        let contacts = []
        for (let contact of this.anotherContacts) {
          if (contact.type && contact.value) {
            contacts.push({
              type: contact.type,
              value: contact.value
            })
          }
        }

        if (contacts.length > 0) {
          this.depData.contacts = contacts
        }
      },
      next () {
        if (this.isStepValid()) {
          this.setPhones();
          this.setAnotherContacts();
          this.$emit('getData', this.depData)
          this.$emit('nextStep')
          this.$root.$emit('resetScroll')
        }
      },
      prev () {
        this.$emit('prevStep')
      },
      resetData () {
        this.depData = {
          description: '',
          contacts: [{type: '', value: ''}],
          address: ''
        }
      }
    },
    watch: {
      depData: {
        handler: function (val, oldVal) {
          this.resetError();
        },
        deep: true
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';
.dep-create-form {
  &__map-address {
    margin-bottom: 30px;
  }
  &__map {
    min-height: 355px;
    margin-top: -10px;
    margin-bottom: 25px;
  }

  &__map-buttons {
    padding-top: 15px;
  }

  &__map-cancel {
    cursor: pointer;
    color: $link-color;
  }
}
.dep-create-another-contacts {
  margin-bottom: 25px;

  .el-input {
      margin-bottom: 0 !important;
    }

  &__row {
    margin-bottom: 25px;
    display: grid;
    grid-template-columns: .5fr 1fr 20px;
    grid-column-gap: 15px;
    align-items: center;

    @media (max-width: $screen-sm){
      grid-template-columns: 1fr;
    }
  }

  &__add {
    margin-top: 15px;
    color: #2196F3;
    cursor: pointer;

    &:hover {
      color: lighten(#2196F3, 15%);
    }
  }

  &__delete {
    cursor: pointer;
    /* margin-bottom: 25px;
    margin-top: -28px;
    span {
      font-size: 12px;
      color: #2196F3;
      cursor: pointer;

      &:hover {
        color: lighten(#2196F3, 15%);
      }
    } */
  }
}
</style>